<app-popup-layout #modal class="d-none d-md-block">
    <div class="modal-container">
      <img
        (click)="modal.close()"
        class="help-screen-close-button ms-auto me-xl-n5"
        src="/assets/svg/model-close-btn.svg"
        alt="close"
      />
    
      <img src="assets/svg/voucher-claim-failed.svg" class="w-2/5" alt="Failed Voucher Generation" />

      <p class="font-size-14 font-medium text-center mb-4 text-danger">
        {{ data }}
      </p>

      <p class="font-size-14 font-medium text-center">
        <a (click)="redirectToLogin(); modal.close()" class="login"> Login </a> into reward portal & buy brand gift vouchers
      </p>      

      <div class="col-12 col-sm-12 col-md-12 mb-12 mt-4 d-flex justify-content-center">
        <button mat-flat-button color="accent" (click)="modal.close()" class="cancel-btn d-block me-4">
            OK
        </button>
      </div>

    </div>
</app-popup-layout>

<div class="d-block d-md-none">
  <app-action-sheet-controller [isVisible]="true" [overlay]="false" [noHeader]="false">
    <ng-container *ngTemplateOutlet="failurePopup"></ng-container>
  </app-action-sheet-controller>
</div>
<ng-template #failurePopup>
  <div class="modal-container">
    <img
      (click)="modal.close()"
      class="help-screen-close-button ms-auto me-xl-n5"
      src="/assets/svg/model-close-btn.svg"
      alt="close"
    />
  
    <img src="assets/svg/voucher-claim-failed.svg" class="w-3/5" alt="Failed Voucher Generation" />

    <p class="font-size-14 font-medium text-center mt-10 text-danger">
      {{ data }}
    </p>

    <p class="font-size-14 font-medium text-center mt-10">
      <a (click)="redirectToLogin(); modal.close()" class="login"> Login </a> into reward portal & buy brand gift vouchers
    </p>      

    <div class="col-12 col-sm-12 col-md-12 mb-12 mt-12 d-flex justify-content-center">
      <button mat-flat-button color="accent" (click)="modal.close()" class="cancel-btn d-block me-4">
          OK
      </button>
    </div>

  </div>
</ng-template>